<template>
  <p class="is-size-7 has-text-default">
    {{ label }}
    <span v-if="required" class="has-text-danger is-size-8 has-text-weight-normal">
      {{$t('general.labelObligatoire')}}
    </span>
  </p>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
